import Typograf from "typograf";

const typo = new Typograf({ locale: ["ru", "en-US"] });

export const getFixedText = (input: string) => {
	return typo.execute(input);
};

const audio = new Audio("/sounds/click.mp3");
audio.volume = 0.15;

export const playClick = (musicPlay = false) => {
	if (!musicPlay) return;
	audio.currentTime = 0;
	audio.play().catch(() => {});
};
